import React from 'react'
import './index.css';
import Property9 from '../../../component/Explore/Propertypage'

const Property = () => {
  return (
    <div>
      <Property9 num="+91-2934572" type="Duplex Rustic Cabin" desc="Come and enjoy the experience of a Duplex rustic cabin with your family. Enjoy the vibe of a vibrant weather and a cosy location." roomdesc = "Help the elders in their livelihood as cooking bringing veggies and essentials" price = "0" guests="4" bed="2"  bath="2"/>
    </div>
  )
}

export default Property
